export default function EmailEditor({ value, onChange }) {
 return (
 <textarea
 rows={10}
 value={value}
 onChange={e => onChange(e.target.value)}
 placeholder="Write email body (HTML allowed)"
 style={{ width: "100%" }}
 />
 );
}
